export enum VenueOptionsVsitiorEnum {
    contactDataAcquisition = 'contactDataAcquisition',
    visitorRegistration = 'visitorRegistration'
}
